import * as actions from '../actions'

const defaultState = null

export default function messageUsers(state = defaultState, action) {
    switch (action.type) {
        case actions.UNKNOWN_FILTER_GET:
            let newState = state
            if (!action.error) {
                newState = action.payload.data.objects
            }
            return newState

        case actions.UNKNOWN_FILTER_CLEAN:
            return defaultState

        default:
            return state
    }
}
